<template>
  <span>
    <p v-if="contactoDireccion != null">{{ formatLocation() }}</p>
    <p v-if="contactoDireccion != null">{{ formatAdress() }}</p>
  </span>
</template>


<script>
export default {
  name: "Direccion",
  props: ["contactoDireccion"],
  data() {
    return {};
  },
  methods: {
    formatLocation() {
      var strAddress = "";
      if (this.contactoDireccion.literalProvincia)
        strAddress += this.contactoDireccion.literalProvincia.valor;
      if (this.contactoDireccion.valor.codigoPostal) {
        if (strAddress) strAddress += " - ";
        strAddress += this.contactoDireccion.valor.codigoPostal;
      }
      if (this.contactoDireccion.valor.localidad) {
        strAddress += " (" + this.contactoDireccion.valor.localidad + ") ";
      }
      if (this.contactoDireccion.literalPais) {
        if (strAddress) strAddress += " - ";
        strAddress += this.contactoDireccion.literalPais.valor;
      }
      return strAddress;
    },
    formatAdress() {
      var strAddress = "";
      if (this.contactoDireccion.literalTipoVia) {
        strAddress += this.contactoDireccion.literalTipoVia.valor;
      }
      if (this.contactoDireccion.valor.direccion) {
        if (strAddress) strAddress += ", ";
        strAddress += this.contactoDireccion.valor.direccion;
      }
      return strAddress;
    },
  },
};
</script>


<style lang="scss" scoped>
</style>